export default "__VITE_ASSET__DsffHO7E__"